import { jsx as a } from "react/jsx-runtime";
import { c as n } from "../../../clsx-OuTLNxxd.js";
import e from "react";
import { useCarousel as y } from "./carousel.hook.js";
import { defaultBreakpoints as C } from "./types.js";
const N = "_carousel_1eg60_29", t = {
  carousel: N,
  "carousel-content": "_carousel-content_1eg60_33",
  "padding-element-wrapper": "_padding-element-wrapper_1eg60_47"
}, I = ({
  children: s,
  className: c = "",
  paddingElementWrapper: o = !1,
  itemsPerBreakpoint: i = C,
  onNavigationStateChange: u,
  ...m
}, p) => {
  const { carouselRef: l, shouldDisplayPrev: d, shouldDisplayNext: f, scrollPrev: _, scrollNext: x, getItemWidth: h } = y(
    s,
    {
      itemsPerBreakpoint: i,
      paddingElementWrapper: o,
      onNavigationStateChange: u
    }
  ), g = e.Children.map(s, (r, w) => e.isValidElement(r) ? e.cloneElement(r, {
    style: {
      ...r.props.style,
      width: `${h(w)}px`,
      flexShrink: 0
    }
  }) : r);
  e.useImperativeHandle(p, () => ({
    scrollNext: x,
    scrollPrev: _,
    shouldDisplayNext: f,
    shouldDisplayPrev: d,
    carouselElement: l.current
  }));
  const v = n(t.carousel, c);
  return /* @__PURE__ */ a("div", { className: v, ...m, children: /* @__PURE__ */ a(
    "div",
    {
      role: "list",
      ref: l,
      className: n(t["carousel-content"], o && t["padding-element-wrapper"]),
      tabIndex: 0,
      children: g
    }
  ) });
}, W = e.forwardRef(I);
export {
  W as Carousel
};
